/**
 * Opens a <details> accordion when the URL fragment targets it
 * (or targets anything inside it). Runs on initial load and on hashchange.
 * Plain page loads without a matching hash are untouched.
 */
(() => {
  const getTargetFromHash = () => {
    const raw = window.location.hash.slice(1);
    if (!raw) return null;

    let id;
    try {
      id = decodeURIComponent(raw);
    } catch {
      id = raw; // malformed encoding: fall back to the raw value
    }

    // getElementById avoids CSS-selector escaping issues with odd hashes.
    return document.getElementById(id);
  };

  const openAncestors = (target) => {
    let details = target.matches('details') ? target : target.closest('details');
    if (!details) return false;

    // Open the matched accordion plus any parent <details> (nested accordions).
    while (details) {
      if (!details.open) details.open = true;
      details = details.parentElement?.closest('details') ?? null;
    }
    return true;
  };

  const handleHash = ({ smooth = false } = {}) => {
    const target = getTargetFromHash();
    if (!target || !openAncestors(target)) return;

    // Opening changes layout; wait a frame, then align the target.
    requestAnimationFrame(() => {
      target.scrollIntoView({
        block: 'start',
        behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'smooth'
          : 'auto',
      });
    });
  };

  // Initial direct link (script is deferred, so the DOM is parsed).
  handleHash();

  // In-page links like <a href="#how-to-use">.
  window.addEventListener('hashchange', () => handleHash({ smooth: true }));
})();